import { ResponsiveLine } from '@nivo/line';
import { green, yellow } from 'theme/theme.constant';
import { linearGradientDef } from '@nivo/core';

// const renderTooltip = () => {};
function LineChart(props) {
	const wrappedData = () => {
		return [
			{
				id: props.id || 'bar',
				data: props.data,
			},
		];
	};
	const getTickValues = () => {
		let data = props.data;
		let tickValues = [];
		if (data.length > 10 && data.length <= 16) {
			for (let idx in props.data) {
				if (idx % 2 === 0) {
					tickValues.push(props.data[idx].x);
				}
			}
		} else if (data.length > 16) {
			for (let idx in props.data) {
				if (idx % 3 === 0) {
					tickValues.push(props.data[idx].x);
				}
			}
		} else {
			tickValues = props.data.map((tick) => tick.x);
		}
		return tickValues;
	};
	const getCommonProps = () => {
		let commonProps = {
			margin: { top: 20, right: 30, bottom: 25, left: 30 },
			curve: 'linear',
			enableCrosshair: false,
		};
		if (props.gradient) {
			commonProps.curve = 'monotoneX';

			commonProps.fill = [{ match: '*', id: 'gradientA' }];
			commonProps.defs = [
				linearGradientDef('gradientA', [
					{ offset: 0, color: 'inherit' },
					{ offset: 100, color: 'inherit', opacity: 0 },
				]),
			];
			commonProps.enableArea = true;
			commonProps.enableSlices = false;

			commonProps.enableCrosshair = props.enableCrosshair;
		}
		if (props.onSelect) {
			if (props.activeMarker !== null) {
				commonProps.markers = [
					{
						axis: 'x',
						value: props.activeMarker,
						lineStyle: { stroke: props.color, strokeWidth: 2, strokeDasharray: '4 4' },
					},
				];
			}
		}
		return commonProps;
	};

	return (
		<ResponsiveLine
			key={props.id}
			data={wrappedData()}
			{...getCommonProps()}
			xScale={{ type: 'point' }}
			yScale={{
				type: 'linear',
				min: '0',
				max: 'auto',
				stacked: false,
				reverse: false,
			}}
			axisTop={null}
			axisRight={null}
			axisBottom={{
				orient: 'bottom',
				tickSize: 0,
				tickPadding: 4,
				tickRotation: 0,
				tickValues: getTickValues(),
			}}
			axisLeft={null}
			colors={props.color}
			enableGridX={false}
			enableGridY={false}
			pointColor={{ from: 'color', modifiers: [] }}
			pointBorderWidth={2}
			pointBorderColor={{ from: 'serieColor' }}
			pointLabelYOffset={-2}
			useMesh={true}
			legends={[]}
			onMouseMove={(point) => {
				if (props.mouseMoveAction) props.onSelect(point);
			}}
			onClick={(point) => {
				if (props.onSelect) props.onSelect(point);
			}}
			tooltip={(point) => {
				return (
					<div className="sliceTooltip">
						<div className="ListDis">
							<div className="Item">
								<div className="left">
									<i style={{ color: yellow[300] }} className="far fa-clock"></i>
									<span>Date/Time</span>
								</div>
								<div className="right">
									<span>{point.point.data.date}</span>
								</div>
							</div>
							<div className="Item">
								<div className="left">
									<i style={{ color: green[300] }} className={props.tooltipLabels.icon}></i>
									<span>{props.tooltipLabels.label}</span>
								</div>
								<div className="right">
									<span>
										{point.point.data.y} {props.tooltipLabels.unit}
									</span>
								</div>
							</div>
						</div>
					</div>
				);
			}}
		/>
	);
}

export default LineChart;
